import React, {useState} from "react";

import style from "./SideBar.module.css"
import HistoryPlayerRequestModal from "./HistoryPlayerRequestModal";
import {useTranslation} from "react-i18next";

function HistoryPlayerRequestTile(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'historyPlayerRequestTile' });
    const [editPopUpOpen, setEditPopUpOpen] = useState(false)

    return (<>
            <div className={style.playerRequestTitle} onClick={() => setEditPopUpOpen(true)}>
                {(props.selectedPlayer.user_request === null || props.selectedPlayer.user_request.length === 0) && <>
                    <div>{t('playerRequest')}</div>
                    <div>{t('clickToEdit')}</div>
                </>}
                {props.selectedPlayer.user_request !== null && props.selectedPlayer.user_request.length > 0 && <>
                    <div>{props.selectedPlayer.user_request.substring(0, 60) + (props.selectedPlayer.user_request.length > 60 ? " ..." : "")}</div>
                </>}
            </div>
            {editPopUpOpen && <HistoryPlayerRequestModal
                gameId={props.gameState.id}
                playerId={props.selectedPlayer.id}
                user_request={props.selectedPlayer.user_request}
                onClose={()=>setEditPopUpOpen(false)}
                updateGameState={props.updateGameState}
            />}
        </>
    )




}

export default HistoryPlayerRequestTile